import React, { useState, useEffect } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import SelectBrand from 'components/select-brand';
import { BrandOption, MealAddonsType } from 'utils/types';
import { Breadcrumbs, ToastMessage } from '@cokitchen/cokitchen-components';
import { useParams } from 'react-router-dom';
import { apiService } from 'services/base.service';
import { ROUTE_KEYS } from 'utils/constants';
import { toast } from 'react-toastify';
import SelectMeal from 'components/search-meal';
import { SuccessModal } from 'components/base/success-modal';
import SingleBottomNav from 'components/base/single-bottom-nav';
import Select from 'components/base/select';

type multiselectOptionsType = {
  value: string;
  text: string;
};

const DuplicateAddon = () => {
  const { id, title, addon_id } = useParams();
  const [selectedBrand, setSelectedBrand] = useState<BrandOption[]>([]);
  const [addonCategory, setAddonCategory] = useState<multiselectOptionsType[]>([]);
  const [selectedMeal, setSelectedMeal] = useState<BrandOption[]>([]);
  const [selectedAddonCategory, setSelectedAddonCategory] = useState<string[]>([]);
  const [addon, setAddon] = useState({} as MealAddonsType);
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAddon();
  }, []);

  const getAddon = async () => {
    try {
      const res = await apiService.post('marketing/addon', {
        data: {
          addon_id: addon_id
        }
      });
      const { data } = res.data;
      setAddon(data[0]);
    } catch (err: any) {
      console.log(err);
    }
  };

  const fetchAddonCategories = async () => {
    if (!selectedMeal?.length) {
      setAddonCategory([]);
      return;
    }

    const mealIds = selectedMeal.map((meal) => meal.value);
    const payload = { meal_ids: mealIds };

    try {
      const res = await apiService.post('internal/meal-addon-category', {
        data: payload,
        isInternal: true
      });
      const { data } = res.data;
      const category = data.map((item: any) => {
        return {
          text: `${item.name} - ${item?.meal?.name}`,
          value: item.id
        };
      });
      setAddonCategory(category);
    } catch (err: any) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchAddonCategories();
  }, [selectedMeal]);

  const handleConfirm = async () => {
    setLoading(true);
    const payload = {
      addon_id,
      addon_category_ids: selectedAddonCategory ?? []
    };
    try {
      await apiService.post('marketing/addons/duplicate-addons', { data: payload });
      setShowSuccess(true);
    } catch {
      toast(<ToastMessage type='error' message='Error encountered while duplicating meal addon' />);
    } finally {
      setLoading(false);
    }
  };

  const breadcrumbs = [
    {
      name: addon.meal_data?.brand?.name ? `View ${addon.meal_data?.brand?.name}` : '...',
      path: `${ROUTE_KEYS.MEALS}?brand_id=${addon.meal_data?.brand_id}`
    },
    {
      name: addon.parent_meal_data?.name ?? '...',
      path: `${ROUTE_KEYS.MEALS}/${addon.meal_data?.meal_category_id}`
    },
    {
      name: 'Addon categories',
      path: `${ROUTE_KEYS.MEALS}/${id}/addon-categories`
    },
    {
      name: 'Duplicate Addon',
      path: ''
    }
  ];
  return (
    <div>
      <div className='max-w-[755px]'>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <PageHeaderText
          title={`Duplicate ${title}`}
          description='This lets you add an add-on to various meals'
        />
        <div className='space-y-5 text-[14px]'>
          <div>
            <p className='mb-2 font-medium'>Select brand</p>
            <SelectBrand brands={selectedBrand || []} setBrands={setSelectedBrand} multiple />
          </div>

          <div>
            <p className=' font-medium'>Select meal</p>
            <SelectMeal
              selectedBrand={selectedBrand}
              selectedMeal={selectedMeal || []}
              setSelectedMeal={setSelectedMeal}
              multipleBrands
              hasSearch
              multiple
            />
          </div>

          <div>
            <p className=' font-medium'>Select add-on category (you may select multiple options)</p>
            <Select
              multiple
              placeholder='Select Category'
              options={addonCategory}
              values={selectedAddonCategory}
              onChange={setSelectedAddonCategory}
            />
          </div>
        </div>
        <SingleBottomNav
          loading={loading}
          btnDisabled={!selectedBrand || !selectedMeal || selectedAddonCategory?.length === 0}
          onConfirm={handleConfirm}
        />
      </div>
      {showSuccess && (
        <SuccessModal show={showSuccess} onClose={() => setShowSuccess(false)}>
          Addon duplicated successfully
        </SuccessModal>
      )}
    </div>
  );
};

export default DuplicateAddon;
